export interface IPlaqueItem{
    id?: number;
    itemName?: string;
    itemDisplayId?: string;
    itemLocationName?: string;
    uniquePlaqueId?: string;
    itemTypeId?: number;
    itemBlobUrl?: string;
    itemStatusId?: number;
    itemCampaignTypeId?: number;
}